import SectionCard from '@/components/base/SectionCard';
import ProgressBar from '@/components/base/ProgressBar';
import type { CreatorProfile } from '@/types/portal';

export default function AudiencePanel({ creator }: { creator: CreatorProfile }) {
  const { audience, agencyHistory } = creator;

  return (
    <SectionCard title="Audience & performance" subtitle="Who follows them and how they deliver">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div>
          <p className="mb-3 text-[11px] font-label font-semibold uppercase tracking-wider text-foreground-400">
            Audience split
          </p>
          {audience ? (
            <>
              <div className="space-y-3">
                <div>
                  <div className="mb-1 flex items-center justify-between text-xs text-foreground-600">
                    <span>Women</span>
                    <span className="font-medium text-foreground-900">{audience.women}%</span>
                  </div>
                  <ProgressBar value={audience.women} tone="primary" />
                </div>
                <div>
                  <div className="mb-1 flex items-center justify-between text-xs text-foreground-600">
                    <span>Men</span>
                    <span className="font-medium text-foreground-900">{audience.men}%</span>
                  </div>
                  <ProgressBar value={audience.men} tone="secondary" />
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-3">
                <div className="rounded-md bg-background-100 px-3 py-2.5">
                  <p className="text-[11px] text-foreground-400">Top age band</p>
                  <p className="font-heading text-sm font-semibold text-foreground-900">
                    {audience.topAge}
                  </p>
                </div>
                <div className="rounded-md bg-background-100 px-3 py-2.5">
                  <p className="text-[11px] text-foreground-400">Top market</p>
                  <p className="font-heading text-sm font-semibold text-foreground-900">
                    {audience.topMarket}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <p className="rounded-md bg-background-100 px-3 py-4 text-sm text-foreground-500">
              No audience data yet for this creator.
            </p>
          )}
        </div>

        <div>
          <p className="mb-3 text-[11px] font-label font-semibold uppercase tracking-wider text-foreground-400">
            Agency history
          </p>
          <div className="space-y-3">
            <div className="flex items-center justify-between rounded-md border border-background-200 px-3 py-2.5">
              <span className="text-sm text-foreground-600">Campaigns delivered</span>
              <span className="font-heading text-sm font-semibold text-foreground-900">
                {agencyHistory.campaigns}
              </span>
            </div>
            <div className="flex items-center justify-between rounded-md border border-background-200 px-3 py-2.5">
              <span className="text-sm text-foreground-600">On-time delivery</span>
              <span className="font-heading text-sm font-semibold text-foreground-900">
                {agencyHistory.onTimeRate != null ? `${agencyHistory.onTimeRate}%` : '—'}
              </span>
            </div>
            <div className="flex items-center justify-between rounded-md border border-background-200 px-3 py-2.5">
              <span className="text-sm text-foreground-600">Average rating</span>
              <span className="font-heading text-sm font-semibold text-foreground-900">
                {agencyHistory.rating != null ? `${agencyHistory.rating} / 5` : '—'}
              </span>
            </div>
            <div className="flex items-center justify-between rounded-md bg-accent-50 px-3 py-2.5">
              <span className="text-sm text-accent-800">Reputation tier</span>
              <span className="font-heading text-sm font-semibold text-accent-800">
                {agencyHistory.rating == null
                  ? 'Not rated'
                  : agencyHistory.rating >= 4.7
                    ? 'Preferred'
                    : 'Established'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </SectionCard>
  );
}